<template>
  <div>
    <AnnouncementWrapper
      caretPosition="left"
      :class="$style.announcement"
      header="Check out VPP"
      :localStorageKey="vppPopoverDismissedLocalStorageKey"
      text="Apple's Volume Purchase Program allows you to purchase applications in bulk,
            and remotely deploy and manage them on Mac devices."
      @main-action="handlePopoverMainAction"
    />
    <TabList
      :activeTab="activeTabIndex"
      :customActiveTabStyle="$style.activeTab"
      :customNavStyle="$style.tabNav"
      :customTabStyle="$style.tabLink"
      :tabs="tabs"
      @active-tab-change="handleActiveTabChange"
    />
  </div>
</template>

<script>
import { LocalStorageConsts, MdmTabsIndex } from 'client/util/Constants';
import AnnouncementWrapper from 'client/components/Announcement/AnnouncementWrapper.vue';
import MdmSettingsMainPanel from 'client/MDM/MdmSettingsMainPanel.vue';
import TabList from 'components/TabList/TabList.vue';
import Util from 'client/util/Util';
import VppSettingsMainPanel from 'client/MDM/VppSettingsMainPanel.vue';

export default {
  name: 'MdmVppMainPanel',

  components: {
    AnnouncementWrapper,
    TabList,
  },

  props: {
    itemType: {
      default: '',
      type: String,
    },
    viewport: {
      default: null,
      type: Object,
    },
  },

  data: () => ({
    activeTabIndex: 0,
    openTokenForm: false,
    vppPopoverDismissedLocalStorageKey: LocalStorageConsts.vppAnnouncementPopoverDismissed,
  }),

  computed: {
    tabs() {
      return [
        {
          title: 'Home',
          component: MdmSettingsMainPanel,
          componentProps: {
            itemType: this.itemType,
            viewport: this.viewport,
          },
        },
        {
          title: 'VPP',
          component: VppSettingsMainPanel,
          componentProps: {
            openTokenForm: this.openTokenForm,
          },
        },
      ];
    },
  },

  created() {
    this.handleCreated();
  },

  methods: {
    handleActiveTabChange(tabIndex) {
      this.activeTabIndex = tabIndex;
      this.openTokenForm = false;
    },

    handleCreated() {
      const params = Util.getQueryStringParameter('params');
      if (params) {
        const paramsParsed = JSON.parse(params);
        const { selectedTab, openTokenForm } = paramsParsed;
        this.activeTabIndex = selectedTab;
        this.openTokenForm = openTokenForm;
        Util.removeQueryStringParameter('params');
      }
    },

    handlePopoverMainAction() {
      this.handleActiveTabChange(MdmTabsIndex.vpp);
    },
  },
};
</script>
<style module>
@value (jcGrey, jcGrey600) from '~css/brand-colors.css';

.activeTab a {
  border: 2px solid var(--jcPrimary);
  border-radius: 16px;
  color: jcGrey600;
  font-size: 1.2rem;
  font-weight: 600;
  padding: 0.5rem 0.75rem;
}

.announcement {
  left: 60px;
  position: absolute;
  top: 55px;
}

.tabLink {
  color: jcGrey !important;
  font-size: 16px;
  font-weight: bold;
  padding: 0.5rem 0.75rem;
}

.tabNav {
  margin: 20px 0 10px 20px !important;
}
</style>
